import { toast } from "sonner";

function formatResult(m) {
  const a = m.open_result || "***";
  const b = m.jodi_result || "**";
  const c = m.close_result || "***";
  return `${a}-${b}-${c}`;
}

function ActionBtn({ label, onClick, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className="btn-navy shrink-0 w-[68px] sm:w-[80px] text-xs sm:text-sm !py-2 !px-2 justify-center"
    >
      {label}
    </button>
  );
}

function MarketRow({ market }) {
  const result = formatResult(market);
  const live = !!market.is_live;
  const openCharts = () =>
    toast.message("Charts", { description: `${market.name} — chart view coming soon.` });

  return (
    <div
      className={`relative px-3 sm:px-5 py-4 sm:py-5 flex items-center gap-3 sm:gap-5 border-t border-[#b8001f]/60 ${
        live
          ? "bg-gradient-to-r from-[#ffe970] via-[#fff2a1] to-[#ffe970]"
          : "bg-[#faf1de]"
      }`}
      data-testid={`market-row-${market.name.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <ActionBtn label="Jodi" onClick={openCharts} testid={`jodi-btn-${market.id}`} />

      <div className="flex-1 text-center min-w-0">
        <div
          className="font-display font-extrabold text-base sm:text-xl tracking-wide uppercase truncate text-[#14131f]"
        >
          {market.name}
        </div>
        <div className="result-red text-xl sm:text-3xl mt-1">{result}</div>
        {market.time_label && (
          <div className="text-[11px] sm:text-xs mt-1.5 font-semibold tracking-wide text-[#3a3a3a]">
            {market.time_label}
          </div>
        )}
      </div>

      <ActionBtn label="Panel" onClick={openCharts} testid={`panel-btn-${market.id}`} />

      {live && (
        <div className="absolute -top-2 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-[#b8001f] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-widest shadow-[0_2px_8px_rgba(184,0,31,0.5)]">
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
          Live
        </div>
      )}
    </div>
  );
}

function MarketList({ items, testid }) {
  if (!items.length) return null;
  return (
    <div className="rounded-lg overflow-hidden border border-[#b8001f]/70 shadow-[0_6px_20px_rgba(20,19,31,0.08)]" data-testid={testid}>
      {items.map((m) => (
        <MarketRow key={m.id} market={m} />
      ))}
    </div>
  );
}

export default function MarketsSection({ markets }) {
  const day = markets.filter((m) => m.category === "day");
  const night = markets.filter((m) => m.category === "night");

  if (!day.length && !night.length) return null;

  return (
    <section className="bg-dark px-3 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="markets-section">
      <div className="max-w-4xl mx-auto space-y-10">
        <div className="text-center">
          <div className="label-gold">Live Markets</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#ffd700] mt-2">
            Day &amp; Night Results
          </h2>
          <p className="text-[#c9c1a5] mt-3 max-w-xl mx-auto text-sm sm:text-base">
            Tap <span className="text-[#ffd700] font-semibold">Jodi</span> or <span className="text-[#ffd700] font-semibold">Panel</span> on any market to see the chart.
          </p>
        </div>

        {day.length > 0 && (
          <div>
            <div className="flex items-center gap-3 mb-4">
              <h3 className="font-display text-xl sm:text-2xl font-bold text-[#ffd700] tracking-wider">DAY MARKETS</h3>
              <div className="flex-1 red-divider" />
            </div>
            <MarketList items={day} testid="day-markets-list" />
          </div>
        )}

        {night.length > 0 && (
          <div>
            <div className="flex items-center gap-3 mb-4">
              <h3 className="font-display text-xl sm:text-2xl font-bold text-[#ffd700] tracking-wider">NIGHT MARKETS</h3>
              <div className="flex-1 red-divider" />
            </div>
            <MarketList items={night} testid="night-markets-list" />
          </div>
        )}
      </div>
    </section>
  );
}
